import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import { success, failed, successAll, hideModal } from '../actions/DepoActions';

import {
  DEPO_CREATE,
  DEPO_LOAD,
  DEPO_LOAD_ALL,
  DEPO_UPDATE,
} from '../constants/DepoConst';
import MasterDataService from '../services/MasterDataService';
import { BRANCH_CREATE, BRANCH_UPDATE } from '../constants/BranchConst';

export function* list() {
  yield takeEvery(DEPO_LOAD, function* (payload) {
    try {
      const { id } = payload;
      const res = yield call(MasterDataService.getDepoList, id);
      console.log('->>>>>>>>>>');
      yield put(success(res.data.data));
      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      yield put(failed(err));
      console.log(err);
    }
  });
}

export function* listAll() {
  yield takeEvery(DEPO_LOAD_ALL, function* (payload) {
    try {
      const res = yield call(MasterDataService.getDepoListAll, payload);
      console.log('->>>>>>>>>>');
      yield put(successAll(res.data.data));
      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      yield put(failed(err));
      console.log(err);
    }
  });
}

export function* create() {
  yield takeEvery(DEPO_CREATE, function* (payload) {
    try {
      const { data } = payload;
      yield call(MasterDataService.createDepo, data);
      console.log('->>>>>>>>>>');

      const res = yield call(MasterDataService.getDepoListAll);
      yield put(successAll(res.data.data));
      yield put(hideModal());
      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      yield put(failed(err));
      console.log(err);
    }
  });
}
export function* update() {
  yield takeEvery(DEPO_UPDATE, function* (payload) {
    try {
      const { data } = payload;
      yield call(MasterDataService.editDepo, data.id, data);
      console.log('->>>>>>>>>>');

      const res = yield call(MasterDataService.getDepoListAll);
      yield put(successAll(res.data.data));

      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      yield put(failed(err));
      console.log(err);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(list), fork(listAll), fork(create), fork(update)]);
}
